import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "overflow-auto",
  style: {"min-height":"295px"}
}
const _hoisted_2 = { class: "comment-section" }
const _hoisted_3 = { class: "comment-text" }
const _hoisted_4 = {
  key: 1,
  class: "video-section"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 0 }

import {ref, watch, computed, registerRuntimeCompiler} from 'vue';
import Icon from "@/components/Icons/Icon.vue";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventDetailsModal',
  props: {
  modelValue: [String, Number],

  event: {
    type: Object,
    default: () => {
      return {};
    }
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const router = useRouter();

const props = __props

const dialog = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  dialog.value = newValue;
});

watch(dialog, (newValue) => {
  emit('update:modelValue', newValue);
});

const onJoin = (event: any) => {
  if (!event.link) {
    console.log("event: ", event);
    router.push({name: 'video-session', params: {eventId: event.event.id}});
    return;
  }

  window.location.href = event.link;
}

const isVideo = computed(() => {
  return props.event?.model?.assignee && props.event?.model?.method === 'Video'
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
    "max-width": "400",
    "min-width": "30%",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "font-grey-dark" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createTextVNode(" Details ", -1)),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
              }, [
                _createVNode(Icon, {
                  color: "grey_light",
                  icon: "cross-icon"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_card, { class: "font-grey-dark" }, {
              text: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, [
                    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "comment-title" }, "Consultation Comment:", -1)),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.event.model.consultation.comment), 1)
                  ]),
                  (isVideo.value)
                    ? (_openBlock(), _createBlock(_component_v_divider, {
                        key: 0,
                        class: "my-4"
                      }))
                    : _createCommentVNode("", true),
                  (isVideo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "video-title" }, "Video Link", -1)),
                        _createElementVNode("a", {
                          href: __props.event.model.link,
                          class: "video-link",
                          target: "_blank"
                        }, _toDisplayString(__props.event.model.link), 9, _hoisted_5)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                class: "b-round-20 outline-btn cancel",
                elevation: "0",
                height: "32px",
                "x-small": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (dialog.value = false))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              }),
              (isVideo.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_v_btn, {
                      class: "b-round-20 outline-btn primary-button ml-3",
                      elevation: "0",
                      height: "32px",
                      variant: "outlined",
                      width: "82px",
                      "x-small": "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (onJoin(__props.event?.model)))
                    }, {
                      default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mr-1" }, "Join", -1)),
                        _createVNode(Icon, { icon: "video-icon-lg" })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})